export const MiscellaneousSettingKeyConstant = {
    ShowFilter: 'ShowFilter',
}
